<template>
<div class="row justify-content-center m-0 p-0">
    <div class="col-md-10 col-12">
        <div :id="id" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
            <li v-for="(item, index) in items" :key="index" :data-target="'#' + id" :data-slide-to="index" :class="{ 'active' : index == 0 }"></li>
          </ol>
          <div class="carousel-inner">
            <div class="carousel-item" v-for="(ite, ind) in items" :key="ind" :class="{ 'active' : ind == 0 }">
              <div class="carousel-caption">
                <img :src="ite.imagen" class="imgItem" /> <br class="d-block d-lg-none" /><span class="azul">/</span> <span class="azul">{{ ite.frase }}</span>
                <p v-html="ite.text"></p>
                <h5 v-html="ite.title"></h5>
                <div v-html="ite.puesto" class="puesto"></div>
              </div>
            </div>
          </div>
          <a class="carousel-control-prev" :href="'#' + id" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" :href="'#' + id" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'Clientes',
  props: {
    id: String,
    items: Array,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.carousel-item {
    height: 450px;
}
.carousel-caption {
    color: #000;
    margin: 0;
    bottom: auto !important;
    text-align: left;
    top: 40px !important;
}
.carousel-caption h5 {
    font-weight: 600;
    font-size: 18px;
    margin-top: 30px;
}
.puesto {
    font-size: 14px;
}
.carousel-caption p {
    font-size: 14px;
    margin-top:20px;
}
.carousel-control-prev-icon{
    background-image:url(../assets/images/flechaIzq.svg);
    width: 40px;
    height: 40px;
    margin-right: 20px;
}
.carousel-control-next-icon{
    background-image:url(../assets/images/flechaDer.svg);
    width: 40px;
    height: 40px;
    margin-left: 20px;
}
.carousel-indicators {
    bottom: -50px;
}
.carousel-indicators li {
    width: 12px !important;
    height: 12px !important;
    background: #C0C3E2;
    opacity: 1;
    border-top: none;
    border-bottom: none;
    border-radius: 50%;
    margin-right: 10px;
    margin-left: 10px;
}
.carousel-inner {
    background: url('../assets/images/comillas.svg');
    background-position: 88% 50%;
    background-repeat: no-repeat;
}
.carousel-indicators li.active {
    background: #08028A;
}
img.comillas {
    width: 60px;
    margin: 60px;
}
img.imgItem {
    height: 125px;
    margin: 10px 20px 10px 0;
}
.azul {
    color: #1900FF;
    font-weight: 600;
}
@media only screen and (max-width: 768px){
    .carousel-item {
        height: 630px;
    }
}
</style>
